import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

const HeroSection = () => {
  const { t } = useTranslation();
  return (
    <section className="text-white bg-[rgb(0,73,69)] md:min-h-screen bg-radial-gradient flex flex-col gap-10 ">
      <div className="flex-1 container flex flex-col justify-center mx-auto px-6 pt-32 text-center max-w-3xl gap-5">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-4 py-2 rounded-full mb-8 w-fit mx-auto text-left"
        >
          <ShieldCheck size={18} className="text-white inline-block" />
          <span className="text-xs sm:text-sm font-medium drop-shadow-sm">
            {t("migrationPage.herosection.badge")}
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-2xl md:text-5xl font-bold mb-6 drop-shadow-sm uppercase"
        >
          {t("migrationPage.herosection.title")}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-white/80 md:text-xl mb-10 leading-relaxed"
        >
          {t("migrationPage.herosection.description")}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 justify-center text-sm md:text-base"
        >
          <a
            href="#instructions"
            className="bg-white text-[#004945] px-8 py-3 rounded-xl font-bold hover:bg-white/90 transition-all"
          >
            {t("migrationPage.herosection.learn")}
          </a>
          <a
            href="#faqs"
            className="border border-white/40 text-white px-8 py-3 rounded-xl font-bold hover:bg-white/10 transition-all"
          >
            {t("migrationPage.herosection.faq")}
          </a>
        </motion.div>
      </div>

      <div className="container mx-auto px-6 pb-4 md:pb-10 flex flex-wrap justify-center gap-y-3 gap-x-8 text-white/60 text-sm font-medium">
        <div className="flex items-center gap-2">
          <span className="text-3xl bg-green-500 block rounded-full h-4 w-4" />
          <span>{t("migrationPage.herosection.security")}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-3xl bg-green-500 block rounded-full h-4 w-4" />
          <span>{t("migrationPage.herosection.support")}</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
